import script from "./LoginLogs.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginLogs.vue?vue&type=script&lang=ts&setup=true"

import "./LoginLogs.vue?vue&type=style&index=0&id=425adb6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425adb6e"]])

export default __exports__